import { addHpBlog } from '../blog/blog'
import { createCustomSwiper, _t, isMobile } from '../base'

function createCarousel() {
    const carousel = document.querySelector('#carousel')

    if (!carousel) return

    createCustomSwiper('#carousel .carousel-inner', {
        swiperClass: 'hp-carousel',
        pagination: false,
        arrows: true,
        customOptions: {
            loop: true,
            // autoplay: {
            //     delay: 3000,
            //     disableOnInteraction: true
            // }
        },
    })
}

function renameButtons() {
    const buttons = document.querySelectorAll('.hp_to_cat')

    if (buttons.length > 0) {
        buttons.forEach((button) => {
            if (button) {
                button.textContent = _t('show_all')
            }
        })
    }
}

function createProductsCarousel() {
    if ($(window).width() <= 1184) {
        const $productsBlock = $('.in-index .products-block')

        // First destroy if already initialized
        if ($productsBlock.length && $productsBlock.hasClass('slick-initialized')) {
            $productsBlock.slick('destroy')
        }

        // Then initialize new slick carousel
        $productsBlock.slick({
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 2.1,
            slidesToScroll: 2,
            // autoplay: true,
            autoplaySpeed: 4000,
        })
    }
}

function createBlogCarousel() {
    if ($(window).width() <= 767) {
        $('.in-index .news-wrapper').slick({
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1.1,
            slidesToScroll: 1,
            autoplay: false,
        })
    }
}

function convertToEmbedUrl(url) {
    const videoId = url.match(/\/shorts\/([^?]+)/)?.[1]
    if (!videoId) return url

    return `https://youtube.com/embed/${videoId}`
}

function createYoutubeShorts() {
    const shortsContainer = document.querySelector('.shorts-container')

    if (!shortsContainer) return

    shortsContainer.innerHTML = ''

    Object.values(youtubeShortsLinks).forEach((link) => {
        const videoId = link.match(/\/shorts\/([^?]+)/)?.[1]
        if (!videoId) return

        const shortWrapper = document.createElement('div')
        shortWrapper.className = 'youtube-short thumbnail'
        shortWrapper.dataset.videoUrl = `https://youtube.com/embed/${videoId}`

        const thumbnail = document.createElement('img')
        thumbnail.src = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
        thumbnail.onerror = function () {
            this.src = `https://img.youtube.com/vi/${videoId}/sddefault.jpg`
            this.onerror = function () {
                this.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
            }
        }
        thumbnail.alt = 'Youtube Short thumbnail'
        thumbnail.width = 300
        thumbnail.height = 400
        thumbnail.loading = 'lazy'

        shortWrapper.appendChild(thumbnail)
        shortsContainer.appendChild(shortWrapper)
    })

    document.body.addEventListener('click', function (e) {
        const shortWrapper = e.target.closest('.youtube-short.thumbnail')
        if (!shortWrapper) return

        shortWrapper.classList.remove('thumbnail')
        const iframe = document.createElement('iframe')
        iframe.width = '300'
        iframe.height = '400'
        iframe.src = `${shortWrapper.dataset.videoUrl}?autoplay=1`
        iframe.setAttribute('allowfullscreen', 'allowfullscreen')
        iframe.setAttribute(
            'allow',
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        )

        shortWrapper.innerHTML = ''
        shortWrapper.appendChild(iframe)
    })
}

function categoriesBannerHomepage() {
    $('footer .categories-banner__wrapper').insertAfter($('.categories-banner__placeholder'))
    $('.categories-banner__placeholder').remove()
}

function lazyLoadVideos() {
    const videos = document.querySelectorAll('.carousel-video video')

    videos.forEach((video) => {
        video.addEventListener('loadeddata', () => {
            video.closest('.carousel-video').classList.add('video-ready')

            const thumbnail = video.parentElement.querySelector('.video-thumbnail')
            if (thumbnail) {
                setTimeout(() => {
                    thumbnail.style.opacity = 0
                }, 500)
            }
        })
    })
}

export function initHomepage() {
    createCarousel()
    createProductsCarousel()
    renameButtons()
    createYoutubeShorts()
    categoriesBannerHomepage()
    lazyLoadVideos()
    addHpBlog(4, function () {
        createBlogCarousel()
    })
}
